import { z } from 'zod'

/**
 * L'impact d'une nouvelle version, tel que l'annonce `POST /modules/:id/replacement`
 * (#311, `replacement-impact.ts` côté API). Validé à la réception : c'est une
 * réponse REST, sans type généré.
 */
const replacementImpactSchema = z.object({
  sessionNames: z.array(z.string()),
  completedLearners: z.number(),
  inProgressLearners: z.number(),
  notStartedLearners: z.number(),
  keptScos: z.array(z.string()),
  addedScos: z.array(z.string()),
  removedScos: z.array(z.string()),
  noScoMatch: z.boolean(),
})

export const stagedReplacementSchema = z.object({ revisionId: z.string(), impact: replacementImpactSchema })

export type ReplacementImpact = z.infer<typeof replacementImpactSchema>
export type StagedReplacement = z.infer<typeof stagedReplacementSchema>
